










import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../main/components/main-header/main-header.vue";
import LeftNav from "../components/left-nav.vue";
@Component({
  components: {
    MainHeader,
    LeftNav,
  },
})
export default class AiyyTest extends Vue {}
